import { render, staticRenderFns } from "./FormRO10.vue?vue&type=template&id=1319a6ac"
import script from "./FormRO10.vue?vue&type=script&lang=js"
export * from "./FormRO10.vue?vue&type=script&lang=js"
import style0 from "./FormRO10.vue?vue&type=style&index=0&id=1319a6ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports